import uploadPop from "@/utils/uploadPop";
let isNW = false;
let fs,
  path,
  https,
  http,
  url,
  os,
  child_process,
  nwApp,
  jm,
  del_path,
  uploadUrl;
import { Message } from "element-ui";

if (typeof nw !== "undefined" && nw.require) {
  console.log("[checkUpdate] NW.js 环境");
  isNW = true;
  fs = nw.require("fs");
  path = nw.require("path");
  https = nw.require("https");
  http = nw.require("http");
  url = nw.require("url");
  os = nw.require("os");
  child_process = nw.require("child_process");
  nwApp = nw.App;
  jm = true;
} else {
  console.log("[checkUpdate] 非 NW.js 环境");
}

// 工具函数：确保路径以斜杠结尾
function ensureEndsWithSlash(p) {
  if (!p) return "";
  p = p.replace(/\\/g, "/");
  p = p.replace(/\/+$/, "");
  const idx = p.lastIndexOf("/");
  if (idx !== -1) p = p.substring(0, idx + 1);
  else p = "";
  return p.replace(/\//g, "\\");
}
const delay = (ms) => new Promise((r) => setTimeout(r, ms));
let currentDownload = null; // 当前下载请求
let cancelRequested = false;

/**
 * 下载更新
 * @param {string} u 下载地址
 * @param {object} config uploadPop 配置
 * @returns {object} { cancel: function } 取消下载
 */
function downloadUpdate(u, config = {}) {
  if (!isNW) return;
  if (!u || typeof u !== "string") {
    console.error("[checkUpdate] 无效的 URL:", u);
    return;
  }
  uploadUrl = u;
  jm = config.is_silent;
  cancelRequested = false; // 每次下载前重置
  if (!jm) {
    uploadPop.start(config, cleanup);
  }

  const parsed = url.parse(u);
  const client = parsed.protocol === "https:" ? https : http;
  const tmpDir = ensureEndsWithSlash(process.execPath);
  const tempFilename = `package_new_${Date.now()}.nw`;
  const tempPath = path.join(tmpDir, tempFilename);
  del_path = tempPath;
  const MAX_REDIRECTS = 5;

  const doGet = (requestUrl, redirectsLeft) => {
    if (cancelRequested) return cleanup();
    try {
      const req = client.get(requestUrl, (res) => {
        if (cancelRequested) {
          res.resume();
          return cleanup();
        }

        // 重定向处理
        if (
          res.statusCode >= 300 &&
          res.statusCode < 400 &&
          res.headers.location
        ) {
          if (redirectsLeft > 0) {
            const nextUrl = url.resolve(requestUrl, res.headers.location);
            console.log("[checkUpdate] 重定向到:", nextUrl);
            res.resume();
            doGet(nextUrl, redirectsLeft - 1);
            return;
          } else {
            errHandle("下载失败");
            return cleanup();
          }
        }

        if (res.statusCode !== 200) {
          console.error("[checkUpdate] HTTP 状态码非 200:", res.statusCode);
          errHandle("网络异常");
          res.resume();
          return cleanup();
        }

        const file = fs.createWriteStream(tempPath);
        let downloaded = 0;
        const total = parseInt(res.headers["content-length"], 10) || 0;

        res.on("data", (chunk) => {
          if (cancelRequested) {
            req.abort();
            return cleanup();
          }
          downloaded += chunk.length;
          const percent = total ? Math.floor((downloaded / total) * 100) : null;
          if (percent !== null && !jm) uploadPop.setProgress(percent);
        });

        res.on("error", (err) => {
          if (!cancelRequested) console.error("[checkUpdate] 响应流错误:", err);
          errHandle("网络异常");
          // cleanup();
        });

        file.on("error", (err) => {
          if (!cancelRequested) console.error("[checkUpdate] 写入流错误:", err);
          errHandle("更新失败");
          // cleanup();
        });

        file.on("finish", () => {
          file.close(() => {
            if (!cancelRequested) startUpdater(tempPath);
          });
        });

        res.pipe(file);
      });

      req.on("error", (err) => {
        if (!cancelRequested) console.error("[checkUpdate] 请求失败:", err);
        errHandle("下载失败");
        // cleanup();
      });

      req.setTimeout(2 * 60 * 1000, () => {
        console.error("[checkUpdate] 请求超时");
        req.abort();
        // cleanup();
      });

      currentDownload = req;
    } catch (err) {
      console.error("[checkUpdate] doGet 捕获异常:", err);
    }
  };

  doGet(u, MAX_REDIRECTS);

  function cleanup() {
    cancelRequested = true;
    if (currentDownload) {
      try {
        currentDownload.abort();
      } catch (e) {
        console.error("[checkUpdate] 捕获异常:", e);
        errHandle("关闭失败");
      }
    }
    try {
      if (fs.existsSync(del_path)) fs.unlinkSync(del_path);
    } catch (e) {}
    // uploadPop?.close();
    console.log("[checkUpdate] 下载已取消或完成清理");
  }

  return {
    cancel: () => {
      cancelRequested = true;
      cleanup();
    },
  };
}

/**
 * 更新逻辑
 * @param {string} tempPath 临时下载文件路径
 */
async function startUpdater(tempPath) {
  try {
    const appDir = ensureEndsWithSlash(process.execPath);
    if (!appDir) {
      console.error("[checkUpdate] 无法获取应用目录");
      return;
    }

    const target = path.join(appDir, "package.nw");
    const backup = path.join(appDir, `package_backup_${Date.now()}.nw`);

    if (!fs.existsSync(tempPath)) {
      console.error("[checkUpdate] 临时文件不存在:", tempPath);
      errHandle("文件下载失败");
      return;
    }

    // 备份旧版
    if (fs.existsSync(target)) {
      try {
        fs.renameSync(target, backup);
        console.log("[checkUpdate] 备份成功:", backup);
        // errHandle("更新失败");
      } catch (err) {
        // 必须要走备份 防止崩溃 所以要还原
        console.error("[checkUpdate] 备份失败:", err);
        errHandle("更新失败");
        return;
      }
    }

    // 替换文件，支持重试
    try {
      let retries = 5;

      while (true) {
        try {
          fs.renameSync(tempPath, target);
          console.log("[checkUpdate] 替换成功:", target);
          fs.unlinkSync(backup);
          break;
        } catch (err) {
          if (err.code === "EBUSY" && retries > 0) {
            console.warn(`[checkUpdate] 文件占用，500ms后重试 (${retries})`);
            retries--;
            await delay(500);
            continue;
          } else {
            console.error("[checkUpdate] 替换失败:", err);
            try {
              if (fs.existsSync(backup) && !fs.existsSync(target)) {
                fs.renameSync(backup, target);
                console.log("[checkUpdate] 已恢复备份");
              }
            } catch (e) {
              console.error("[checkUpdate] 恢复备份失败:", e);
              errHandle("更新失败");
            }
            return;
          }
        }
      }
    } catch (err) {
      console.error("[checkUpdate] startUpdater 捕获异常:", err);
      errHandle("更新失败");
    }
    // 删除
    if (fs.existsSync(del_path)) fs.unlinkSync(del_path);
    if (jm) return;
    // 重启 NW.js
    Message({
      message: "更新成功即将重启",
      type: "success",
      duration: 800,
    });
    //  优先级 第一个
    await delay(1300);
    try {
      let nwExe = process.execPath;
      const spawn = child_process.spawn;
      const child = spawn(nwExe, [appDir], {
        detached: true,
        stdio: "ignore",
        cwd: appDir,
      });
      child.unref();

      if (nwApp && typeof nwApp.quit === "function") nwApp.quit();
      else process.exit(0);
    } catch (err) {
      console.error("[checkUpdate] 启动新进程失败:", err);
      errHandle("更新失败");
    }
  } catch (err) {
    console.error("[checkUpdate] startUpdater 捕获异常:", err);
    errHandle("更新失败");
  }
}

// 错误提示 静默刷新不展示
function errHandle(msg = "更新失败，请稍后再试") {
  if (jm) return;
  if (!jm) {
    Message({
      message: msg,
      type: "error",
      duration: 5000,
    });
  }
  const url = uploadUrl.replace(".nw", ".exe");

  uploadPop?.setFailed(url);
}

export { downloadUpdate };
